import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import { Grid, Container, Link, Typography, Box } from '@mui/material';
import { StaticImage } from 'gatsby-plugin-image';

const FooterNavigation = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media only screen and (min-width: 768px) {
    flex-direction: row;
    justify-content: flex-start;
    text-align: left;
  }

  li {
    margin: 0 0 2rem;

    @media only screen and (min-width: 768px) {
      margin: 0 2rem 0 0;
    }

    a {
      color:
      text-decoration: none;
    }
  }
`;

const Footer = () => {
  const {
    allWpCategory: { nodes: allCategories },
  } = useStaticQuery(graphql`
    query CategoriesLinksQuery {
      allWpCategory(
        sort: { fields: acfCategory___order }
        filter: {acfCategory: {active: {eq: true}}}
      ) {
        nodes {
          acfCategory {
            order
          }
          name
          slug
        }
      }
    }
  `);

  return (
    <Grid
      container
      spacing={3}
      justifyContent="center"
      alignItems="center"
      sx={{backgroundColor: '#dbdde0', padding: '2rem', marginTop: 'auto'}}
    >
      <Grid item xs={12}>
        <Container sx={{marginBottom: `2rem`}}>
          <Box sx={{display: 'flex', alignItems: 'center', justifyContent: {xs: 'center', md: 'space-between'}}} mb={4}>
            <FooterNavigation>
              <li>
                <Link href="https://otwarteklatki.pl/o-nas" className="link-regular" target="_blank">
                  O nas
                </Link>
              </li>
              <li>
                <Link href="https://otwarteklatki.pl/kampanie" className="link-regular" target="_blank">
                  Nasze działania
                </Link>
              </li>
            </FooterNavigation>
            <Box sx={{display: {xs: 'none', md: 'block'}}}>
              <StaticImage
              src="../images/ok-full-color.svg"
              alt="Logo"
              placeholder="tracedSVG"
              height={60}
            />
            </Box>
          </Box>
          <hr/>
        </Container>
      </Grid>
      <Grid item xs={12}>
        <Container sx={{marginBottom: `2rem`}}>
          <Typography component="p" variant="caption" align='center'>
            Potrzebujesz pomocy? <br />
            Napisz do nas:{' '}
            <Link href="mailto:pomagam@otwarteklatki.pl" className="link-decoration">
              pomagam@otwarteklatki.pl
            </Link>
          </Typography>
        </Container>
        <Container sx={{display: {xs: 'flex', md: 'none'}, justifyContent: 'center', marginTop: `2rem`}}>
          <StaticImage
            src="../images/ok-full-color.svg"
            alt="Logo"
            placeholder="tracedSVG"
            height={60}
          />
        </Container>
      </Grid>
    </Grid>
  );
};

export default Footer;